var symphony = symphony || {};

;(function() {

	symphony.getLocalStoriesGrid = function($container) {

		$container = $container || $('#storiesIndex');

		if($container.length <= 0){
			return;
		}

		var hiddenPages = hiddenPages || [];

		if(typeof hiddenPages != 'undefined' && !_.isNull(hiddenPages)){

			if(_.indexOf(hiddenPages, 'stories') !== -1){
				getCaringDocs();
			} else {
				getLocalDocs();
			}
		}

		function getLocalDocs(){

			$('body').addClass('loading');

			var url = '/' + siteUrlAlias;
			if (typeof symphony.admin != 'undefined') {
				url += '/admin'
			}
			var getLocalDocsPromise = $.get(url + '/news/symphony/json?start=0&limit=999&random=' + new Date().getUTCMilliseconds(), function(data){

				if (url.includes('admin')) {
					var response = JSON.parse(data);
				} else {
					var response = JSON.parse(unescape(decodeURI(data)).replace(/\+/g,' '));//data;//JSON.parse(data);
				}

				var news = [];
				_.each(response.objects, function(item) {
					if (item.customHeadContent) {
						var chd = JSON.parse(item.customHeadContent);
						if (chd === null) {
							return
						}
						news.push(item)
					}
					
					
				});

				var allNews = []
				var featuredAndMostRecent = [];

				_.each(news, function(story){
					if(!story.published) {
						return;
					}

					if (story.customHeadContent && story.customHeadContent != null && typeof story.customHeadContent == 'string'){
						story.customHeadContent = JSON.parse(story.customHeadContent);
					}

					if (story.customHeadContent !== null && story.customHeadContent.featured) {
						featuredAndMostRecent.push(story)
					} else {
						allNews.push(story);
					}						
				});

				if (featuredAndMostRecent.length < 8 && allNews.length >= 8) {
					var count = featuredAndMostRecent.length;

					_.each(allNews, function(story) {
						if (count >= 8) {
							return;
						}
						featuredAndMostRecent.push(story)
						count++;
					})
				}
				
				_.forEach(featuredAndMostRecent, function(news, i) {
					if (news.customHeadContent && news.customHeadContent != null && typeof news.customHeadContent == 'string'){
						news.customHeadContent = JSON.parse(news.customHeadContent);
					}
				});

				var localStories = {
					mostRecent: featuredAndMostRecent,
					activeDocs: allNews
				}

				$container.empty().append(symphony.templates.storiesGridIndex({stories:localStories}));

				$('body').removeClass('loading');
			}, 'text');
		}

		function getCaringDocs(){

			$('body').addClass('loading');

			if(sessionStorage && !_.isNull(sessionStorage.getItem('caringStories'))){

				var localStories = JSON.parse(sessionStorage.getItem('caringStories'));
				$('#storiesIndex').empty().append(symphony.templates.storiesGridIndex({stories:localStories}));

				$('body').removeClass('loading');

			} else {

				var getCaringDocsPromise = $.get('//caringmagazine.org/wp-json/wp/v2/posts?filter[tag]=impact&per_page=9');

				getCaringDocsPromise.done(function(data){
					
					var localStories = {
						mostRecent: data.slice(0,8),
						activeDocs: data
					};

					// Additional call to get the Featured Image for each post
					$.each(localStories.activeDocs, function(i, story){
						var featuredImage = $.get('//caringmagazine.org/wp-json/wp/v2/media/' + story.featured_media);
						story.title = story.title.rendered;
						story.description = story.excerpt.rendered;
						delete story.author;
						featuredImage.done(function(data) {

							localStories.activeDocs[i].media = data;
							localStories.activeDocs[i].headerImage = story.media.source_url;

							// Store the results to sessionStorage for faster retrieval
							sessionStorage.setItem('caringStories', JSON.stringify(localStories));

							$('#storiesIndex').empty().append(symphony.templates.storiesGridIndex({stories:localStories}));

							$('body').removeClass('loading');

						});
					});
					
				});
			}
		}
	};
})();
